import React, { useState, useEffect } from "react";
import {
	Card, Label
} from "reactstrap";

export default function StepTwo({
	setSetupProgress, selectedMicrophone, selectMicrophone
}) {

	const [devices, setDevices] = useState([]);

	useEffect(() => {
		
		navigator.mediaDevices.enumerateDevices().then((devs) => {
			const microphones = devs.filter((device) => device.kind === "audioinput");
			setDevices(microphones);
		});
	}, []);

	const handleChange = (e) => {
		selectMicrophone(e.target.value);
		setSetupProgress(prev => ({
			...prev,
			stepThree: true
		}));
	};

	return (
		<Card className="p-4 mb-3 visibility-visible">
			<div className="title mb-4">
				<span className="me-2 step-number">2</span>Select Audio Input Device
			</div>

			<div className="select-device">
				<Label htmlFor="select-mic">Select Device</Label>
				<select
					className="form-control"
					id="select-mic"
					value={selectedMicrophone}
					onChange={handleChange}
				>
					<option value="0">Select Microphone</option>
					{devices.map((device, i) => {
						return (
							<option key={i} value={device.deviceId}>{device.label || `Microphone ${i + 1}`}</option>
						)
					})}
				</select>
			</div>
		</Card>
	);
};